"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var coreConfig = require("@react-form-fields/core/config");
var defaultConfig = {
    validationOn: 'onChange',
    dateFormat: 'yyyy-MM-dd',
    dateLabels: {
        clear: 'Clear',
        ok: 'Ok',
        cancel: 'Cancel'
    },
    trumbowyg: {
        loadLocale: function () { return Promise.resolve(); },
        loadPlugins: function () { return []; },
        config: {}
    }
};
function getConfig() {
    return tslib_1.__assign({}, defaultConfig, (coreConfig.getConfig() || {}));
}
exports.getConfig = getConfig;
function setConfig(config) {
    coreConfig.setConfig(config);
}
exports.setConfig = setConfig;
//# sourceMappingURL=index.js.map